import IMG from "../../assets/images/avatar.svg";

interface UserWithImageNameTitleProps {
  img?: string;
  name: string;
  title: string;
}

export default function UserWithImageNameTitle({
  img = IMG,
  name,
  title,
}: UserWithImageNameTitleProps) {
  return (
    <div className="flex-1 flex items-center gap-4 h-full">
      <div className="w-10 h-10">
        <img className="w-full h-fuw-full rounded-full" src={img} alt="" />
      </div>
      <div className="flex flex-col gap-0.5">
        <h3 className="text-body font-medium leading-normal">{name}</h3>

        <p className="text-body-text text-sm leading-normal">{title}</p>
      </div>
    </div>
  );
}
